export default __webpack_public_path__ + "static/media/sista.8f465fe8.jpg";